import React from 'react';
import { FaBirthdayCake, FaUsers, FaClock, FaEuroSign, FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

// Import your local images here. Make sure the paths and filenames are correct.
import birthday1 from '../assets/birthday1.jpg'; // Example image
import birthday2 from '../assets/birthday4.jpg'; // Example image
import birthday3 from '../assets/birthday3.jpg'; // Example image
import birthday4 from '../assets/birthday2.jpg'; // Example image

const packages = [
  {
    nameKey: 'birthday.packages.small',
    people: '8 do 12',
    courts: '2-3',
    price: '15',
    imageUrl: birthday1,
  },
  {
    nameKey: 'birthday.packages.medium',
    people: '12 do 16',
    courts: '3-4',
    price: '14',
    imageUrl: birthday2,
  },
  {
    nameKey: 'birthday.packages.large',
    people: '16 do 20',
    courts: '4-5',
    price: '13',
    imageUrl: birthday3,
  },
  {
    nameKey: 'birthday.packages.maxi',
    people: '32',
    courts: '8',
    price: '12',
    imageUrl: birthday4,
  },
];

const BirthdayPackages = () => {
  const { t } = useTranslation();

  return (
    <>
      <header className="service-page-header">
        <h1>{t('birthday.title')} <FaBirthdayCake /></h1>
        <p>
          {t('birthday.subtitle')}
        </p>
      </header>

      <div className="packages-container" style={{ padding: '2rem 0' }}>
        {packages.map((pkg) => (
          <div
            key={pkg.nameKey}
            className="package-card"
            style={{ backgroundImage: `url(${pkg.imageUrl})` }}
          >
            <div className="package-card-overlay"></div>
            <div className="package-card-content">
              <h3 className="package-name">{t(pkg.nameKey)}</h3>
              <ul className="package-details">
                <li><FaUsers /> {t('birthday.people', { count: pkg.people })} ({t('birthday.courts', { count: pkg.courts })})</li>
                <li><FaClock /> {t('birthday.duration')}</li>
                <li><FaEuroSign /> {pkg.price} {t('birthday.price_per_person')}</li>
              </ul>
            </div>
          </div>
        ))}
      </div>
      <div className="birthday-content-bottom">
        <p className="birthday-contact">
          {t('birthday.contact_text')}
        </p>
        <div className="birthday-buttons-container">
          <a href="#contact" className="birthday-button contact-button">
            {t('birthday.contact_form_button')}
          </a>
          <a href="https://wa.me/385913782937" target="_blank" rel="noopener noreferrer" className="birthday-button whatsapp-button">
            <FaWhatsapp /> {t('birthday.whatsapp_button')}
          </a>
        </div>
      </div>
    </>
  );
};

export default BirthdayPackages;
